import { useTranslation } from 'react-i18next';

import { EMPTY_VALUE } from '@/utils/placeholders';

import { RESULT_STYLE } from './ResultPill.constants';
import type { ResultPillProps } from './ResultPill.types';

export const ResultPill = ({ result }: ResultPillProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'resultPill' });

	if (!result) return <span className="text-[12px] text-subtle">{EMPTY_VALUE}</span>;

	const { icon: Icon, className, labelKey } = RESULT_STYLE[result];

	return (
		<span
			className={`inline-flex items-center gap-3xs rounded-md px-2xs py-3xs text-[11px] font-medium leading-none ${className}`}
		>
			<Icon className="h-[12px] w-[12px] shrink-0" aria-hidden="true" />
			{t(labelKey)}
		</span>
	);
};
